import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { IntegrationMonitorDto, IntegrationMonitorPagedRequestDto } from '../integration-monitors/models';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class IntegrationStatusService {
  apiName = 'Default';
  

  executeIntegrationManuallyByIntegrationStatusId = (integrationStatusId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/integration-status/execute-integration-manually/${integrationStatusId}`,
    },
    { apiName: this.apiName,...config });
  

  getAllByInput = (input: IntegrationMonitorPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IntegrationMonitorDto>>({
      method: 'GET',
      url: '/api/app/integration-status',
      params: { serviceEntrySheetId: input.serviceEntrySheetId, operation: input.operation, state: input.state, dateFrom: input.dateFrom, dateTo: input.dateTo, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
